import React, { useState } from "react";
import { req } from "../api";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [partner_code, setPartnerCode] = useState("");
  const [accountType, setAccountType] = useState("personal");
  const [companyName, setCompanyName] = useState("");

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await req("/api/auth/register", {
        method: "POST",
        body: {
          email,
          password,
          first_name,
          last_name,
          phone,
          partner_code,
          accountType,
          companyName: accountType === "company" ? companyName : "",
        },
      });
      if (!r.json?.ok) throw new Error(r.json?.error || "Register failed");
      nav("/payments");
    } catch (e2) {
      setErr(String(e2.message || e2));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ maxWidth: 520, margin: "40px auto", padding: 16 }}>
      <h2>Poteme Pay — Register</h2>
      {err ? <div style={{ color: "crimson", marginBottom: 10 }}>{err}</div> : null}
      <form onSubmit={submit} style={{ display: "grid", gap: 10 }}>
        <label>Email<input value={email} onChange={(e) => setEmail(e.target.value)} /></label>
        <label>Password<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} /></label>

        <label>First name<input value={first_name} onChange={(e) => setFirstName(e.target.value)} /></label>
        <label>Last name<input value={last_name} onChange={(e) => setLastName(e.target.value)} /></label>
        <label>Phone<input value={phone} onChange={(e) => setPhone(e.target.value)} /></label>
        <label>Partner code<input value={partner_code} onChange={(e) => setPartnerCode(e.target.value)} /></label>

        <label>
          Account type
          <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
            <option value="personal">personal</option>
            <option value="company">company</option>
          </select>
        </label>

        {accountType === "company" ? (
          <label>Company name<input value={companyName} onChange={(e) => setCompanyName(e.target.value)} /></label>
        ) : null}

        <button disabled={loading} type="submit">{loading ? "..." : "Create account"}</button>
      </form>
    </div>
  );
}
